import React from 'react';
import { useUI } from '../../contexts/UIContext';

const getPotentialTier = (potential: number): { label: string, className: string, description: string } => {
    if (potential > 90) return { label: 'ELITE', className: 'potential-elite', description: 'Generational Talent (91+)' };
    if (potential > 85) return { label: 'STAR', className: 'potential-star', description: 'World Class Player (86-90)' };
    if (potential > 80) return { label: 'KEY', className: 'potential-key', description: 'Leading Star Player (81-85)' };
    if (potential > 75) return { label: 'GOOD', className: 'potential-good', description: 'Good Squad Player (76-80)' };
    if (potential > 65) return { label: 'DECENT', className: 'potential-decent', description: 'Decent Squad Player (66-75)' };
    return { label: 'AVG', className: 'potential-average', description: 'Average Player (<=65)' };
};


interface PotentialBadgeProps {
    potential: number;
}

export const PotentialBadge: React.FC<PotentialBadgeProps> = ({ potential }) => {
    const { openPotentialInfoModal } = useUI();
    const tier = getPotentialTier(potential);
    const title = `Potential: ${potential} (${tier.description}). Click for more info.`;

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        openPotentialInfoModal(potential);
    };

    return (
        <button className="potential-badge-button" onClick={handleClick} title={title}>
            <span className={`potential-badge ${tier.className}`}>
                {tier.label}
            </span>
        </button>
    );
};
